enum MoveType {
  Magic = 'magic',
  Physical = 'physical',
  Support = 'support',
}

export default MoveType;
